function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import keyBy from 'lodash/keyBy';
export var easeInOutQuad = function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}; // We need a unique string id so lockBody() calls coming from different places don't interfere with each other

export var lockBody = function lockBody(id) {
  var locked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (typeof document !== 'undefined') {
    // Preserve original classes in case there are any
    var bodyClassNames = keyBy(document.body.className.split(' '), function (className) {
      return className;
    });
    document.body.className = classNames(_objectSpread(_objectSpread({}, bodyClassNames), {}, _defineProperty({}, "app-athena-locked-".concat(id), locked)));
  }
};
export var windowSmoothScrollY = function windowSmoothScrollY(y) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var useBrowserScrollBehaviorIfSupported = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var isScrollBehaviorSupported = typeof document.documentElement.style.scrollBehavior !== 'undefined';

  if (isScrollBehaviorSupported && useBrowserScrollBehaviorIfSupported) {
    window.scrollTo({
      left: 0,
      top: y,
      behavior: 'smooth'
    });
  } else {
    var initialScrollY = window.pageYOffset;
    var finalScrollY = y;
    var totalTime = time;
    var initialTime = Date.now();
    var interval = setInterval(function () {
      var elapsedTime = Date.now() - initialTime;

      if (elapsedTime <= totalTime) {
        var elapsedTimePercentage = elapsedTime / totalTime;
        var scale = easeInOutQuad(elapsedTimePercentage);
        var newScrollY = (finalScrollY - initialScrollY) * scale + initialScrollY;
        window.scrollTo(0, newScrollY);
      } else {
        clearInterval(interval);
        window.scrollTo(0, finalScrollY);
      }
    }, 5);
  }
};